<style>
    .ly-information {
        width: 100%;
        border-top:1px solid #dfe6ec;
        border-left:1px solid #dfe6ec;
    }
    .ly-information td {
        font-size: 12px;
        color:#1f2d3d;
        border-bottom:1px solid #dfe6ec;
        border-right:1px solid #dfe6ec;
        line-height: 24px;
        padding: 6px 16px;
        width: 21.333333%;
    }
    .ly-information tr td:nth-child(2n+1) {
        font-weight: 600;
        background-color: #eef1f6;
        width: 12%
    }
</style>
<template>
    <table class="ly-information" cellspacing="0">
        <tr v-for="el in configToTr">
            <template v-for="item in el" v-if="item">
                <td>{{item.label}}</td>
                <td :colspan="item.colspan">
                    <template v-if="item.config && item.config.component == 'tag'">
                        <el-tag type="warning">{{data[item.prop]}}</el-tag>
                    </template>
                    <template v-else>
                        {{data[item.prop]}}
                    </template>
                </td>
            </template>
        </tr>
    </table>
</template>
<script>
    export default {
        name: 'LyInformation',
        props: {
            /**
             * config配置示例：
               ［{
                    label: '名称',
                    prop: 'name',
                    colspan: '3'
                }］
             */
            config: Array, // 配置
            data: Object // 具体的详情数据
        },
        computed: {
            /**
             * 配置转为表格的多行多列
             */
            configToTr () {
                let table = [] // 配置列表的存放
                let row = [] // 一行
                let len = 0 // 记录每一行的长度
                let wrap = (l) => { // 换行处理函数
                    table.push(row)
                    row = []
                    len = l
                }
                for (let i in this.config) {
                    if (len === 3) { // 每行3对数据
                        wrap(0)
                    } 
                    // 有跨列的情况
                    if (this.config[i]['colspan']) {
                        switch (this.config[i]['colspan']) {
                            case '3':
                                if (len > 1) { // 已有两列数据时，跨列处理
                                    wrap(2)
                                } else {
                                    len = 3
                                }
                            break;
                            case '5':
                               wrap(3)
                            break;
                        }
                    } else {
                        len++
                    }
                    // 添加一列数据
                    row.push(Object.assign({}, this.config[i]))
                }
                if (row.length > 0) {
                    table.push(row)
                }
                return table
            }
        }
    }
</script>